import React from "react";

export default function MarketList({ matches }) {
  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "--";
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(hour, minute, 0, 0);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getBettingStatus = (openTime, closeTime) => {
    const now = new Date();
    // const todayDate = new Date(now.toDateString());

    // const matchDate = new Date(betDate);

    const [openHour, openMinute] = openTime.split(":").map(Number);
    const [closeHour, closeMinute] = closeTime.split(":").map(Number);

    const open = new Date();
    open.setHours(openHour, openMinute, 0, 0);

    const close = new Date();
    close.setHours(closeHour, closeMinute, 0, 0);

    const preOpen = new Date(open.getTime() - 15 * 60 * 1000);
    const preClose = new Date(close.getTime() - 15 * 60 * 1000);

    // if (now < preOpen || matchDate > todayDate) {
    //   return {
    //     status: "running",
    //     message: "Betting is Running Now",
    //   };
    // }
    if (now < preOpen) {
      return {
        status: "running",
        message: "Betting is Running Now",
      };
    }

    if (now >= preOpen && now < preClose) {
      return {
        status: "running_close",
        message: "Betting is Running for Close",
      };
    }
    if (now >= preClose) {
      return {
        status: "closed",
        message: "Betting is Closed for Today",
        color: "text-red-500",
      };
    }
  };
  const getCleanResult = (value) =>
    value && value.trim() !== "" ? value : "**";
  return (
    <div>
      {Object.entries(matches).map(([matchName, entries]) => {
        const data = entries[0];
        const openTime = data?.open_time;
        const closeTime = data?.close_time;
        // const betDate = data?.draw_date;
        const { status, message } = getBettingStatus(
          openTime,
          closeTime,
        );
        const filteredEntries = entries.filter(
          (item) => item?.type_id === 2 || item?.type_id === 5
        );
        const singlePattiOpenResult = getCleanResult(
          filteredEntries[0]?.open_result
        );
        const singlePattiCloseResult = getCleanResult(
          filteredEntries[0]?.close_result
        );

        // const jodiOpenResult = getCleanResult(filteredEntries[1]?.open_result);
        const getLastDigitOfSum = (val) => {
          if (!val || val.length !== 3) return "*";
          const sum = val
            .split("")
            .reduce((acc, digit) => acc + parseInt(digit, 10), 0);
          return String(sum % 10); 
        };

        const derivedJodiClose =
          status === "closed" || status === "running_close"
            ? `${getLastDigitOfSum(singlePattiOpenResult)}${getLastDigitOfSum(
                singlePattiCloseResult
              )}`
            : "**";
        const resultText =
          status === "closed" || status === "running_close"
            ? `${singlePattiOpenResult || "***"}-${derivedJodiClose}-${
                singlePattiCloseResult || "***"
              }`
            : "***-**-***";
        return (
          <a
            href={`/game-detail/${data.match_name_id}/`}
            key={matchName}
            onClick={(e) => {
              if (status === "closed") {
                e.preventDefault();
              }
            }}
          >
            <div className="flex flex-col gap-3 mb-1">
              <div className="flex items-center justify-between bg-white rounded border border-m_gray shadow-md text-xs leading-[10px] px-2">
                <div className="w-1/4 text-center">
                  <div className="flex flex-col items-center gap-2">
                    <span className="font-semibold">Open Time</span>
                    <span>{formatTimeTo12Hour(openTime)}</span>
                  </div>
                </div>

                <div className="w-1/2 text-center py-1">
                  <span className="block font-semibold text-gray-800 text-lg">
                    {matchName}
                  </span>
                  <p
                    className={`text-xxs ${
                      status === "running"
                        ? "text-green-600"
                        : status === "running_close"
                        ? "text-green-600"
                        : status.startsWith("closed")
                        ? "text-m_red"
                        : ""
                    }`}
                  >
                    {message}
                  </p>
                  <span className="block text-sm text-m_peach font-bold pt-0.5 tracking-wider">
                    {resultText}
                  </span>
                </div>

                <div className="w-1/4 text-center">
                  <div className="flex flex-col items-center gap-2">
                    <span className="font-semibold">Close Time</span>
                    <span>{formatTimeTo12Hour(closeTime)}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
}
